import {
  applyMarketingConsentFromConsentData,
  grantedCategoriesFromConsentData,
  notifyFromConsentResponse,
  recreateScripts,
} from './cookie_consent';

export const CONSENT_STUDIO_UPDATED_EVENT = 'consent-studio__updated';

// Consent Studio: functional = necessary + preferences (always on).
// Optional opt-ins: analytics → statistics, marketing → marketing.
export function consentAttributesFromVendorCategories(grantedNames) {
  const granted = Array.isArray(grantedNames) ? grantedNames : [];

  return {
    preferences: true,
    statistics: granted.includes('analytics'),
    marketing: granted.includes('marketing'),
  };
}

export async function postConsentAdjust(attributes) {
  const response = await fetch('/cookies/adjust', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
    },
    credentials: 'same-origin',
    body: JSON.stringify(attributes),
  });

  const data = await response.json();
  notifyFromConsentResponse(data);
  applyMarketingConsentFromConsentData(data);
  recreateScripts(grantedCategoriesFromConsentData(data));
}

export function syncConsentStudioUpdatedEvent(event) {
  const grantedNames = event && event.detail && event.detail.categories;
  if (!Array.isArray(grantedNames)) {
    return;
  }

  return postConsentAdjust(consentAttributesFromVendorCategories(grantedNames));
}

export function startConsentStudioSync() {
  window.addEventListener(CONSENT_STUDIO_UPDATED_EVENT, syncConsentStudioUpdatedEvent);
}
